import React from 'react';

import { Loader, Stack, Text } from '@mantine/core';

export function LoadingContainer({ height, text }: { height?: number | string; text?: string }) {
  return (
    <Stack justify="center" align="center" h={height} w="100%">
      <Loader color="dimmed" />
      {text ? <Text c="dimmed">{text}</Text> : null}
    </Stack>
  );
}
